<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="24" >
                <el-card class="box-card" :style="'height:'+bodyHeight+'px'">
                    <div slot="header" class="clearfix">
                        <el-button type="primary" size="small" @click="add"  icon="el-icon-plus" plain>添加</el-button>
                         <el-input
                            size="small"
                            style="width:300px;margin-left:30px;"
                            placeholder="请输入姓名 / 账号"
                            prefix-icon="el-icon-search"
                            @keydown.enter.native="query"
                            v-model="queryModel.queryTxt">
                        </el-input>
                        <el-select size="small" style="margin-left:30px;width:100px"  v-model="queryModel.type" clearable placeholder="兼职类型">
                            <el-option key="1" label="出纳" value="1"> </el-option>
                            <el-option key="2" label="审核" value="2"> </el-option>
                        </el-select>
                        <el-tooltip class="item" effect="dark" content="查询" placement="top">
                            <el-button type="primary" size="small" style="margin-left:30px;" @click="query" icon="el-icon-search" plain circle></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="重置" placement="top">
                            <el-button type="primary" size="small" style="margin-left:15px;" @click="reset" icon="el-icon-aim" plain circle></el-button>
                        </el-tooltip>
                        <el-pagination
                        style="float:right"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryModel.pIndex"
                        :page-sizes="[20, 40, 60, 80]"
                        :page-size="queryModel.pSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                        </el-pagination>
                    </div>
                    <el-table
                    v-loading="isLoading"
                    :data="tableData"
                    :height="bodyHeight-130"
                    style="width: 100%">
                        <el-table-column
                            prop="Name"
                            label="姓名">
                        </el-table-column>
                        <el-table-column
                            prop="Phone"
                            label="账号">
                        </el-table-column>
                        <el-table-column
                            label="类型">
                            <template slot-scope="scope">
                                <el-tag size="mini" effect="plain" type="" v-if="scope.row.Type==1">出纳</el-tag>
                                <el-tag size="mini" effect="plain" type="warning" v-else>审核</el-tag>
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="余额">
                            <template slot-scope="scope">
                                <el-link v-if="scope.row.Type==2"   type="info">暂无</el-link>
                                <el-link v-else @click="recharge(scope.row)"  icon="el-icon-money" type="primary">￥{{scope.row.Balance}}</el-link>
                            </template>
                        </el-table-column>

                        <el-table-column
                            prop="CreateTime"
                            label="注册时间">
                        </el-table-column>

                        <el-table-column
                            label="操作">
                            <template slot-scope="scope">
                                  <el-button type="primary" size="mini" @click="update(scope.row)"  icon="el-icon-edit" circle></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
        <el-dialog title="添加人员" :visible.sync="dialogFormVisible" width="400px">
            <el-form :model="newModel"  :rules="rules" ref="ruleForm" label-width="80px">
                <el-form-item label="姓名：" prop="Name">
                    <el-input placeholder="请输入真实姓名" v-model="newModel.Name"></el-input>
                </el-form-item>
                <el-form-item label="账号：" prop="Phone">
                    <el-input placeholder="请输入登录账号" v-model="newModel.Phone"></el-input>
                </el-form-item>
                <el-form-item label="角色：" prop="Type">
                    <el-radio-group v-model="newModel.Type">
                        <el-radio :label="1">出纳</el-radio>
                        <el-radio :label="2">审核</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="修改余额" :visible.sync="setBalanceVisible" width="500px">
            <el-form   label-width="80px">
                <el-form-item label="类型：" prop="Title">
                      <el-radio-group v-model="setBalanceModel.type">
                            <el-radio :label="1">转账给他（充值）</el-radio>
                            <el-radio :label="4">他转给我（扣款）</el-radio>
                        </el-radio-group>
                </el-form-item>
                <el-form-item label="金额：" >
                    <el-input v-model="setBalanceModel.money" placeholder="￥"></el-input>
                </el-form-item>
                <el-form-item label="备注：" >
                    <el-input v-model="setBalanceModel.description" placeholder="请输入备注信息"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="setBalanceVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitSetBalance">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { outsiderGet,outsiderSave,outsiderRecharge} from '@/request.js'
export default {
    data(){
        return {
            setRow:{},
            setBalanceVisible:false,
            setBalanceModel:{
                type:1,
                description:"",
                money:0,
                outsiderId:0,
            },
            dialogFormVisible:false,
            total:0,
            bodyHeight:0,
            isLoading:false,
            queryModel:{
                queryTxt:"",
                pSize:20,
                pIndex:1,
                type:"",
            },
            tableData:[],
            newModel:{
                Id:0,
                Phone:"",
                Name:"",
                Type:0,
            },
            rules: {
                Name: [
                    { required: true, message: '请填写人员名称', trigger: 'blur' },
                    { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
                ],
                Phone: [
                    { required: true, message: '请填写人员账号', trigger: 'blur' },
                    { min: 2, max: 15, message: '长度在 2 到 15 个字符', trigger: 'blur' }
                ],
                Type: [
                    { required: true, message: '请选择人员角色', trigger: 'change' }
                ],
            },
            roleList:[]
        }
    },
    created(){
        this.bodyHeight=document.documentElement.clientHeight-129;
        this.query();
    },
    mounted(){
       
    },
    methods: {
        submitSetBalance(){
            if(this.setBalanceModel.money<=0){
                this.$message({
                    type: 'info',
                    message: '金额请输入正整数'
                });     
                return;
            }
            outsiderRecharge(this.setBalanceModel,(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        var money=parseFloat(this.setBalanceModel.type==1? this.setBalanceModel.money:-this.setBalanceModel.money);
                        this.setRow.Balance+=money;
                        this.setBalanceVisible=false;
                    }else{
                        this.$message.error(res.Message);
                    }
            });
        },
        recharge(scope){
            this.setRow=scope;
            this.setBalanceModel.outsiderId=scope.Id;
            this.setBalanceVisible=true;
        },
        update(scope){
            this.newModel={
                Id:scope.Id,
                Phone:scope.Phone,
                Type:scope.Type,
                Name:scope.Name,
            };
            this.dialogFormVisible=true;
        },
        submitForm() {
            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    outsiderSave({
                        Id:this.newModel.Id,
                        Name:this.newModel.Name,
                        Type:this.newModel.Type,
                        Phone:this.newModel.Phone,
                    },(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            this.dialogFormVisible=false;
                            this.query();
                        }else{
                            this.$message.error(res.Message);
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        add(){
            this.newModel={
                Id:0,
                Phone:"",
                Name:"",
                Type:0,
            };
            this.dialogFormVisible=true;
        },
        query(){
            this.isLoading=true;
            outsiderGet({
                queryTxt:this.queryModel.queryTxt,
                pSize:this.queryModel.pSize,
                pIndex:this.queryModel.pIndex,
                type:this.queryModel.type==""?0:parseInt(this.queryModel.type),
            },(res)=>{
                this.tableData=res.Result;
                this.total=res.TotalCount;
                setTimeout(() => {
                    this.isLoading=false;
                }, 300);
            })
        },
        reset(){
            this.queryModel={
                type:"",
                queryTxt:"",
                pSize:this.queryModel.pSize,
                pIndex:this.queryModel.pIndex,
            }
        },
        handleSizeChange(val){
            this.queryModel.pSize=val;
            this.query();
        },
        handleCurrentChange(val){
            this.queryModel.pIndex=val;
            this.query();
        }
    }
}
</script>
<style >
.el-dialog__body{
    padding:10px 20px;
}
</style>